export default __webpack_public_path__ + "static/screen-classic-mac-laptop@2x-fad7595375d09a1c9bf2821ef9e604e5.webp";